export class BuildDate { public static readonly stamp = '1683038160996'; }